<label class="form-label">{{ label }}</label>
<code-editor [(ngModel)]="html" [ngModelOptions]="{standalone: true}" [extensions]="extensions" class="html-editor" (change)="onChange()"/>
